.slider{width:1024px}.number-line{width:1024px;margin:0 auto;display:block}
/*# sourceMappingURL=chain-100.component-4CICZ7ST.css.map */
